import {ENDPOINT_URL} from 'constants/index';

import getFetchOptions from 'utils/getFetchOptions';

const COUNTRY = process.env.REACT_APP_COUNTRY || 'norway';

export async function deleteLanguageKey(locale, key, app = 'backoffice') {
	const response = await fetch(
		`${ENDPOINT_URL}/language-config`,
		getFetchOptions({
			method: 'DELETE',
			body: JSON.stringify({country: COUNTRY, app, locale, key}),
		})
	);
	if (!response.ok) throw new Error('Failed to delete');
	return response.json();
}

export default deleteLanguageKey;
